// add new languages here
export const availableLocales = [
  'de_DE',
  'de_AT',
  'de_CH',
  'de_LU',
  'en_US',
  'en_CA',
  'cs_CZ',
  'da_DK',
  'el_GR',
  'en_GB',
  'en_IE',
  'en_XH',
  'en_MY',
  'en_SG',
  'es_ES',
  'fi_FI',
  'fr_CH',
  'fr_BE',
  'fr_FR',
  'fr_CA',
  'fr_LU',
  'hu_HU',
  'ko_KR',
  'it_IT',
  'it_CH',
  'nl_NL',
  'nl_BE',
  'pl_PL',
  'pt_PT',
  'ro_RO',
  'sk_SK',
  'sv_SE',
  'tr_TR',
  'zh_TW',
] as const;
// define the fallback order to translate missing keys
export const fallbacks = ['en_US', 'de_DE'];
export const isNafta = (locale: string): boolean => {
  const country = locale.split('_')[1];
  const naftaCountries = ['US', 'CA'];
  return naftaCountries.some((c) => c === country);
};
